/* The Teams Roster card, ported from app.ts (teamCard ~2739, memberRow ~2731).
   It builds the SAME HTML the vanilla client did, and a card built by hand
   keeps esc() on every interpolated identity value exactly as the vanilla
   source did (CONTRACT §5). TeamsView renders the string via
   dangerouslySetInnerHTML.

   The allocation block under each member — their committed rows, the
   per-month totals and the Allocate button — went with allocations
   themselves (MVP cut, Sep 14 2026). What is left is what the Entra roster
   actually records: who is on the team, and the red gap row when no manager
   is. That is also what intake reads a team for. */
import type { Team, Member } from "../../../shared/teams";
import { esc } from "../../esc";
import { managerGapRow } from "../shell/sections";

function memberRow(mem: Member): string {
  const badge = mem.state === "unconfirmed" ? `<span class="state unconfirmed">unconfirmed</span>` : "";
  return `<li><span class="slot-main">
    <span class="slot-name">${esc(mem.name)}${badge}<span class="stamp">${esc(mem.source)}</span></span>
    ${mem.note ? `<div class="slot-note">${esc(mem.note)}</div>` : ""}</span></li>`;
}

/* The Roster card (D14): no card head — the team is named once, in the
   navigator heading (D13), and a recorded manager has no row here at all; the
   roster is the reports, plus a red gap row when no manager is recorded. The
   `teams-roster` class identifies the card now that its title is gone. */
export function teamCardHtml(t: Team): string {
  const members = t.members.length
    ? t.members.map((m) => memberRow(m)).join("")
    : `<li><span class="slot-main"><div class="slot-note">No members recorded.</div></span></li>`;
  return `<section class="card confirmed teams-roster">
    <ul class="slots">${managerGapRow(t.manager)}${members}</ul></section>`;
}
